module.exports = __webpack_public_path__ + "assets/img/huanzhe.49cd151c.png";